import { useState, useMemo } from 'react'
import { post } from '@api/apiFetcher'
import { useRouter } from 'next/router'
import mutateUser from '@utils/user/mutateUser'
import useRedirect from '@hooks/useRedirectBack'
import MessageHelper from '@utils/messageHelper'

const NEXT_PUBLIC_IMAGE_SERVICE = process.env.NEXT_PUBLIC_IMAGE_SERVICE
const EMPTY_ACTION = new Promise((resolve) => resolve())

const API = (type) => `/api/offers/${type}/post`
const API_PHOTO = (pid) => `${NEXT_PUBLIC_IMAGE_SERVICE}/photos/process/${pid}`

const withOfferPostHandler = ({
    type, isSell, isRent, isBuy, isDraft, highlight,
    postPhotos = true, photosName = 'zdjecia',
    customRedirect }) =>

    (TargetComponent) =>
        (props) => {
            const [highlightData, setHighlightData] = useState(false)
            const [redirect, setRedirect] = useRedirect()

            const router = useRouter()
            const path = useMemo(() => API(type), [type])

            const { isTempUser } = props
            const { token: auth } = props.user || {}

            const beforeSubmit = createBeforeSubmitHandler(postPhotos, photosName, auth)
            const onSubmit = (data) => {
                post({ path, auth, data: {
                    isSell,
                    isRent,
                    isBuy,
                    isDraft,

                    ...data,
                }})
                .then(res => {
                    MessageHelper.summary(res)
                    if (!res.success) return

                    beforeSubmit(data)
                        .then(_ => {
                            if (res.user) {
                                mutateUser(props.user, res.user)
                            }

                            if (highlight) {
                                if (isTempUser) return redirect(res.redirect || '/') // <- no data to store invoice
                                if (res.redirect) setRedirect(res.redirect)

                                setHighlightData({
                                    _id: res._id,
                                    type: type,
                                })

                            } else {
                                const goBackTo =
                                       router.query.go_back_to
                                    || customRedirect
                                    || res.redirect

                                redirect(goBackTo)
                            }
                        })
                        .catch(err => null)
                })
                .catch(err => console.log(err))
            }

            return <TargetComponent {...props}
                onSubmit={onSubmit}
                highlight={highlightData} />
        }

function createBeforeSubmitHandler (postPhotos, photosName, auth) {
    return postPhotos
        ? (data) => {
            if (data[photosName] && data[photosName].length > 0) {
                return post({
                    path: API_PHOTO(data.pid),
                    auth,
                    data: {
                        photos: data[photosName].map(String)
                    }})
                    .then(res => MessageHelper.summary(res))

            } else {
                return EMPTY_ACTION
            }
          }

        : EMPTY_ACTION
}

export default withOfferPostHandler